module.exports = __webpack_public_path__ + "img/3de7bedac03c022359e21c8146bd64f0.c84d8450.jpg";